// The canonical Phoebe mark, inlined so it takes currentColor like a lucide
// icon. Renders the shared brand path rather than a redrawn flower — brand
// rules forbid redrawing the mark.
import { type ReactNode } from 'react';

import { PHOEBE_MARK_PATH } from '@apps/web/components/ui/phoebe_mark';
import { cn } from '@apps/web/lib/utils';

export type FlowerMarkProps = Readonly<{
    readonly className?: string;
}>;

export function FlowerMark({ className }: FlowerMarkProps): ReactNode {
    return (
        <svg
            viewBox="35 35 108 108"
            fill="currentColor"
            className={cn('overflow-visible', className)}
            aria-hidden="true"
            focusable="false"
        >
            <g>
                <path d={PHOEBE_MARK_PATH} />
            </g>
        </svg>
    );
}
